import React from 'react';

interface SolutionArchitectConsultantIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const SolutionArchitectConsultantIcon: React.FC<SolutionArchitectConsultantIconProps> = ({
  color = '#2372b9',
  height = 36,
  width = 36,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 36 36"
    fill="none"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
  >
    <path
      fill={color}
      d="M23.9704 6.8002H24.4004C26.1654 6.8002 27.6004 8.2352 27.6004 10.0002V27.6002C27.6004 29.3652 26.1654 30.8002 24.4004 30.8002H11.6004C9.83539 30.8002 8.40039 29.3652 8.40039 27.6002V10.0002C8.40039 8.2352 9.83539 6.8002 11.6004 6.8002H12.0304C12.5804 5.8452 13.6154 5.2002 14.8004 5.2002H21.2004C22.3854 5.2002 23.4204 5.8452 23.9704 6.8002ZM20.8004 10.8002C21.4654 10.8002 22.0004 10.2652 22.0004 9.6002C22.0004 8.9352 21.4654 8.4002 20.8004 8.4002H15.2004C14.5354 8.4002 14.0004 8.9352 14.0004 9.6002C14.0004 10.2652 14.5354 10.8002 15.2004 10.8002H20.8004ZM18.0004 17.6002C18.8054 17.6002 19.4604 18.2552 19.4604 19.0602C19.4604 19.4952 19.3054 19.7552 19.1154 19.9452C18.8904 20.1652 18.5804 20.3202 18.2754 20.4202C17.5304 20.6702 16.8004 21.3852 16.8004 22.3952C16.8004 23.0602 17.3354 23.5952 18.0004 23.5952C18.5754 23.5952 19.0604 23.1902 19.1754 22.6452C20.1354 22.2902 21.8604 21.3302 21.8604 19.0552C21.8604 16.9252 20.1304 15.1952 18.0004 15.1952C15.8704 15.1952 14.1404 16.9252 14.1404 19.0552C14.1404 19.7202 14.6754 20.2552 15.3404 20.2552C16.0054 20.2552 16.5404 19.7202 16.5404 19.0552C16.5404 18.2502 17.1954 17.5952 18.0004 17.5952V17.6002ZM19.4004 26.0002C19.4004 25.2252 18.7754 24.6002 18.0004 24.6002C17.2254 24.6002 16.6004 25.2252 16.6004 26.0002C16.6004 26.7752 17.2254 27.4002 18.0004 27.4002C18.7754 27.4002 19.4004 26.7752 19.4004 26.0002Z"
    />
  </svg>
);

export default SolutionArchitectConsultantIcon;